module.exports = __webpack_public_path__ + "static/assets/2aca27aec8b96d42222461d5ff6688bc.svg";